// extracted by mini-css-extract-plugin
export var fadeInOut = "_1v-3";
export var icon = "_1v-4";
export var savedIndicator = "_1v-2";
export var savingIndicator = "_1v-0";
export var spin = "_1v-1";